import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import Icon, { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import ds from '../Services/DataServices'
import IntlMessages from '../util/IntlMessages'
import {
  Layout,
  Card,
  Col,
  Row,
  Button,
  Divider,
  Checkbox,
  InputNumber,
  Modal,
  Input,
  Form,
  Tooltip,
  message,
  Popconfirm
} from 'antd'
import { formatTimeStr } from 'antd/lib/statistic/utils'
import { deepStrictEqual } from 'assert'
import enums from '../assets/ENUMS/enums'
import { loadData } from '../appRedux/actions/Setting'
import { BEHAVIOUR_TYPE } from '../Services/DataServices'
import { notAllowMsgCheck } from '../appRedux/actions'
import { TableName } from '../constants/TableName'

const confirm = Modal.confirm

const AddProductTags = props => {
  const [visible, setVisible] = React.useState(false)
  const [editTag, seteditTag] = React.useState('')
  const [confirmLoading, setConfirmLoading] = React.useState(false)
  const [modalText, setModalText] = React.useState('Content of the modal')
  const [addTagText, setAddTagText] = React.useState('')

  const [form] = Form.useForm()
  const store = useStore()
  const dispatch = useDispatch()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 24 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 24 }
    }
  }
  const showModal = () => {
    setVisible(true)
  }

  const handleOk = async values => {
    setConfirmLoading(true)
    const methodType =
      props.behavior == '1'
        ? BEHAVIOUR_TYPE.POST
        : props.behavior == '2'
        ? BEHAVIOUR_TYPE.DELETE
        : BEHAVIOUR_TYPE.UPDATE
    const postValues = {
      ProductTagName: values.addTag ? values.addTag : '',
      BehaviorName: props.behavior == '1' ? 1 : props.behavior == '2' ? 2 : 3,
      ProductTagGuid:
        props.behavior == '3'
          ? props.recordId
          : props.behavior == '2'
          ? props.recordId
          : '00000000-0000-0000-0000-000000000000'
    }
    await ds
      .addUpdateDeleteProductTags(postValues, methodType)
      .then(data => {
        setConfirmLoading(false)
        // message.success(data.data.msgDescription + "Product Tag" + " " + values.addTag);
        if(props.behavior == '2'){
          message.success('Product Tag deleted successfully !')
        }
        else{
        message.success(data.data.msgDescription + ' Product Tag')
        }
        dispatch(loadData(true))
        form.resetFields()
        setVisible(false)
      })
      .catch(response => {
        notAllowMsgCheck(response)
        setConfirmLoading(false)
        message.error('ERROR occured')
      })
  }

  const handleCancel = () => {
    setVisible(false)
  }

  useEffect(() => {
    if (props.valueText != 'undefied') {
      form.setFieldsValue({ addTag: props.valueText })
    }
    return () => {
      form.resetFields()
    }
  })

  function onOk () {
    form
      .validateFields()
      .then(values => {
        handleOk(values)
      })
      .catch(info => {})
  }

  function onFailed () {
    // message.error("");
  }

  function showDeleteConfirm (brandID, brandName) {
    confirm({
      title: 'Kindly Confirm',
      content: `Are you sure to delete Product Tag?`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        handleOk({})
      },
      onCancel () {
        handleCancel()
      }
    })
  }
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.ProductTags,
      SearchValue: value,
      ID:
        props.behavior == '3'
          ? `${props.tagID}&&_bd98-6131-47dd-8ac8-4bd1856d2a60`
          : `0&&_bd98-6131-47dd-8ac8-4bd1856d2a60`
    }
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST)
    getIsExist
      .then(response => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback('This Product tag name exists. Add a different one.')
        } else {
          callback()
        }
      })
      .catch(e => {})
  }
  return (
    <>
      <div>
        {props.behavior === '1' ? (
          <Button
            type='primary'
            className='dk-btn-add ProductTags-addbtn'
            onClick={showModal}
            size='large'
          >
            <IntlMessages id='products.productTags.addTag' />
          </Button>
        ) : props.behavior === '3' ? (
          <span>
            <a onClick={showModal} className='pen-edit'>
              <i className='icon icon-edit' />
            </a>
          </span>
        ) : // <EditOutlined onClick={showModal} />
        props.behavior === '2' ? (
          <>
            <span>
              <a onClick={() => showDeleteConfirm()} style={{ color: 'red' }}>
                <i className='icon icon-trash' />
              </a>
            </span>
            {/* <Popconfirm
              title="Are you sure to delete?"
              onConfirm={handleOk}
              onCancel={handleCancel}
              okButtonProps={{ loading: confirmLoading }}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined />
            </Popconfirm> */}
          </>
        ) : (
          ''
        )}

        <Modal
          title={<IntlMessages id='products.productTags.productTags' />}
          visible={visible}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
          centered={true}
          className='ProductTags-Modal'
          footer={
            <>
              <Button
                form='addATagForm'
                className='dk-btn-add'
                type='primary'
                htmlType='submit'
              >
                {props.behavior == '1' ? (
                  <IntlMessages id='products.productTags.addTag' />
                ) : (
                  <IntlMessages id='products.productTags.updateTag' />
                )}
              </Button>
            </>
          }
          onOk={() => {
            form
              .validateFields()
              .then(values => {
                handleOk(values)
              })
              .catch(info => {})
          }}
        >
          <Form
            {...formItemLayout}
            form={form}
            // layout="vertical"
            name='addATagForm'
            initialValues={{
              prefix: '86',
              modifier: 'public'
            }}
            onFinish={onOk}
            onFinishFailed={onFailed}
            scrollToFirstError
          >
            <Form.Item
              className='form-inner-pad-0'
              name={'addTag'}
              label={
                props.behavior === '1' ? (
                  <IntlMessages id='products.productTags.addTag' />
                ) : (
                  <IntlMessages id='products.productTags.editTag' />
                )
              }
              rules={[
                {
                  required: true,
                  message: (
                    <IntlMessages id='products.productTags.tagMessageRequired' />
                  )
                },
                {
                  validator: valideDuplicateName
                }
              ]}
            >
              <Input  maxLength={30}/>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </>
  )
}
export default AddProductTags
